<template>
  <div>
    <div class="i-header">
      <div class="i-h-menu">
        <a href="/index" :class="index=='0'?'active':''">首页</a>
        <a href="#xyou">新游</a>
        <a href="#glue">攻略</a>
        <a href="#video">视频</a>
        <!-- <a href="#glue">新游</a> -->
        <!-- <a>活动</a> -->
        <a href="https://dhgm.xyz/bbs/">猎人大厅</a>
        <!-- <a>联系</a> -->
      </div>
      <a class="i-h-logo"></a>
      <!-- <a class="i-h-login-btn">登录/注册</a> -->
    </div>
    <div class="i-lead" style="display:none;">
      <div class="i-l-right">
        <a target="_blank" href="https://discord.gg/p7QCHPntuf" class="discord">
          <img src="/static/img/dc.png" />
        </a>
        <a target="_blank" href="https://twitter.com/DigitalHunterCN" class="twitter">
          <img src="/static/img/tw.png" />
        </a>
        <a target="_blank" href="https://www.youtube.com/@DigitalHunter2023" class="youtube">
          <img src="/static/img/yt.png" />
        </a>
        <a target="_blank" class="bili" href="https://space.bilibili.com/96909396">
          <img src="/static/img/bili.png" />
        </a>
        <a>
          <el-tooltip placement="top">
            <div slot="content">
              <div class="i-gz">关注公众号</div>
              <img src="/static/img/qrcode.jpg" />
            </div>
            <img src="/static/img/wx.png" />
          </el-tooltip>
        </a>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Header',
  props: {
    index: {
      type: String,
      default: '0'
    }
  },
  data () {
    return {}
  },
  methods: {
    // login(){
    //   console.log(111)
    // }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.i-header {
  background-color: #d6f5fa;
  position: relative;
  height: 80px;
  z-index: 1;
  .i-h-logo {
    position: absolute;
    width: 88px;
    height: 88px;
    background-image: url("/static/img/logo2-1.png");
    left: 177px;
    top: -5px;
  }
  .i-h-login-btn {
    position: absolute;
    width: 172px;
    height: 60px;
    background-image: url("/static/img/dlzc_bg.png");
    top: 10px;
    right: 160px;
    text-align: center;
    line-height: 60px;
  }
  .i-h-content {
    padding-left: 10px;
    height: 30px;
    margin: 0 auto;
    line-height: 30px;
    color: #333;

    i {
      color: #333;
      position: absolute;
      left: 0;
      top: 7px;
    }
    .i-h-tem {
      float: left;
      position: relative;
      height: 32px;
      vertical-align: middle;
      padding-left: 13px;
      a:hover {
        color: #ff5c00;
        i {
          color: #ff5c00;
        }
      }
    }
    span {
      padding-left: 5px;
      font-size: 12px;
      padding-right: 10px;
    }
    .line {
      display: block;
      height: 12px;
      background: #333;
      width: 1px;
      filter: alpha(Opacity=30);
      position: absolute;
      left: 74px;
      top: 10px;
      margin: 0 auto;
    }
  }
}
.i-lead {
  // width: 1280px;
  height: 94px;
  // margin-left: auto;
  // margin-right: auto;
  background-image: url("/static/img/logo6.png");
  background-position: left center;
  background-repeat: no-repeat;
  background-color: #76c5f0;
  .i-l-right {
    float: right;
    height: 60px;
    margin-top: 22px;
    margin-right: 30px;
    a {
      float: left;
      width: 50px;
      height: 50px;
      margin-right: 10px;
      text-align: center;
      vertical-align: middle;
      img {
        margin-top: 5px;
        width: 40px;
      }
    }
  }
}
.i-gz {
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
}
@media (max-width: 768px) {
  .i-lead {
    background-position: -28px 0px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      left: 136px;
      top: 0;
      bottom: 0;
      right: 0;
      background: #76c5f0;
    }
    .i-l-right {
      float: right;
      height: 60px;
      margin-top: 26px;
      margin-right: 0px;
      position: relative;
      a {
        float: left;
        width: 30px;
        height: 30px;
        margin-right: 6px;
        text-align: center;
        vertical-align: middle;
        img {
          width: 30px;
        }
      }
    }
  }
}
.i-h-menu {
  text-align: center;
  height: 80px;
  a {
    display: inline-block;
    width: 160px;
    height: 80px;
    text-align: center;
    line-height: 80px;
    font-size: 21px;
    &.active {
      background-image: url("/static/img/nav_xz.png");
    }
  }
}
</style>
